import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamera = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg238",
	viewBox: "0 0 46 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs242" }), /* @__PURE__ */ _jsx("g", {
		id: "g244",
		transform: "translate(44,-5.2)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "path948",
			style: {
				fill: "#ffffff",
				fillOpacity: 1,
				stroke: "none",
				strokeWidth: 1.2,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 4,
				strokeDasharray: "none",
				strokeOpacity: 1,
				paintOrder: "fill markers stroke"
			},
			d: "m -30.2,6.8 -0.6,0.8 A 4,4 153.43495 0 1 -34,9.2 h -7 a 3,3 135 0 0 -3,3 l 0,30 a 3,3 45 0 0 3,3 l 40,0 a 3,3 135 0 0 3,-3 v -30 a 3,3 45 0 0 -3,-3 H -8 A 4,4 26.565051 0 1 -11.2,7.6 L -11.8,6.8 A 4,4 26.565051 0 0 -15,5.2 l -12,0 a 4,4 153.43495 0 0 -3.2,1.6 z m 9.2,9.4 c 6.075132,0 11,4.924868 11,11 0,6.075132 -4.924868,11 -11,11 -6.075132,0 -11,-4.924868 -11,-11 0,-6.075132 4.924868,-11 11,-11 z m 0,3 c -4.418278,0 -8,3.581722 -8,8 0,4.418278 3.581722,8 8,8 4.418278,0 8,-3.581722 8,-8 0,-4.418278 -3.581722,-8 -8,-8 z"
		})
	})]
});
export { SvgCamera as ReactComponent };
